// Helpers
import { selectSelectedLanguage } from '../reducers/language/languageSelectors';

// Data
import { FORGEROCK_ERRORS } from '../lib/data';

// Requests
import * as backend from '../backend';

// Actions
import * as errorActions from '../reducers/error/errorActions';
import * as sessionActions from '../reducers/session/sessionActions';
import { bodyHasError, walletErrors } from '../lib/validation/serverErrors';
import { signOut } from '../reducers/auth/authActions';

// const isLockedByForgerock = ({ failureUrl }) =>
//   failureUrl === 'User is locked' ||
//   failureUrl ===
//     'Message: Raising fault. Fault name : RF-SC-Error. Error reason: . ServiceCalloutResponse: {"code":401,"reason":"User is locked","message":"Login failure"}. FaultName: RaiseFault.';

//Sleep to be used purely if refresh token call is happening
const sleep = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

let isRefreshing = false;

async function waitForRefresh() {
  if (isRefreshing) {
    // If is currently refreshing wait 2 seconds and check again
    await sleep(2000);

    return await waitForRefresh();
  }
}

const APIMiddleware = ({ dispatch, getState }) => next => async action => {
  if (!action.APIMethod) return next(action);

  // If refresh call is currently happening, make sure for proceding calls to wait until refresh call ends
  await waitForRefresh();

  if (action.type === '[API] KeepAlive Request') {
    isRefreshing = true;

    //Backup in case something goes wrong to set back to false for next call to execute w/o delay
    setTimeout(() => {
      isRefreshing = false;
    }, 5000);
  }

  const selectedLanguage = selectSelectedLanguage(getState());
  action.headers = { ...action.headers, 'Accept-Language': selectedLanguage };

  return backend
    .request(action)
    .then(payload => {
      const { body } = payload;
      next(action);

      // When refresh call is done, set flag back to false
      if (action.type === '[API] KeepAlive Request') {
        isRefreshing = false;
      }

      if (body.expires_in)
        dispatch(sessionActions.updateSession(body.expires_in));

      // if (isLockedByForgerock(body)) {
      //   dispatch({ type: errorActions.ERROR_LOCKOUT, payload });
      // }

      return payload;
    })
    .catch(payload => {
      const { body, response } = payload;

      //When refresh call is done, set flag back to false
      if (action.type === '[API] KeepAlive Request') {
        isRefreshing = false;
      }

      next(action);

      // This suppresses the wallet errors so we can handle them on the payment or deactivate screens
      if (
        (bodyHasError(body, {
          containsExactError: walletErrors,
        }) &&
          response.url.includes('wallet')) ||
        response.url.includes('/delete/blitz')
      ) {
        // handle them on the payment or deactivate screens
      } else if (backend.isServerError({ body, response })) {
        if (
          JSON.stringify(body) ===
          JSON.stringify(FORGEROCK_ERRORS.SESSION_EXPIRED)
        ) {
          return signOut();
        }
        dispatch({ type: errorActions.SERVER_ERROR, payload });
      } else if (
        response.status === 403 ||
        response.status === 402 ||
        response.status === 401
      ) {
        dispatch({ type: errorActions.ERROR_FORBIDDEN, payload });
      }

      return Promise.reject(payload);
    });
};

export default APIMiddleware;
